module.exports = __webpack_public_path__ + "static/media/provider-awcmjili.d971fc86.png";